var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v("Verkoop acties fixen")]),
      _c(
        "w-card-content",
        [
          _c("w-input-number", {
            attrs: { label: "Bookjaar", decimals: 0 },
            model: {
              value: _vm.bookyear,
              callback: function ($$v) {
                _vm.bookyear = $$v
              },
              expression: "bookyear",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.submitting, icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.submitting, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v("Bevestigen")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }